module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/filterIcon-01bd2d69e14c5329ba1bfc2b5f1cfc1c.png";